import { Injectable } from '@angular/core';
import { Produto } from '../produto/produto';
import { User, Api } from '..';

export class Pedido {
  public numPedido: number;
  public seriePedido: string;
  public dataPedido: string;
  public idCliente: number;
  public razaoSocial: string;
  public idCondPag: number;
  public idVendedor: number;
  public qtdTotal: number;
  public totalNota: number;
  public observacao: string;
  public movped: MovPed[];

  constructor() {
    this.numPedido = 0;
    this.seriePedido = 'W01';
    this.dataPedido = '';
    this.idCliente = 0;
    this.razaoSocial = '';
    this.idCondPag = 0;
    this.idVendedor = 0;
    this.qtdTotal = 0;
    this.totalNota = 0;
    this.observacao = '';
    this.movped = [];
  }
}

export class MovPed {
  public seriePedido: string;
  public numPedido: number;
  public idCliente: number;
  public idProduto: number;
  public nomeReduzido: string;
  public qtd: number;
  public vlrUnit: number;
  public subTotal: number;
  public vlrTot: number;
  public numSeq: number;
  public acrescimo: number;
  public datMov: string;
  public produto: Produto;

  constructor() {
    this.seriePedido = '';
    this.numPedido = 0;
    this.idCliente = 0;
    this.nomeReduzido = '';
    this.idProduto = 0;
    this.qtd = 1;
    this.vlrUnit = 0;
    this.subTotal = 0;
    this.vlrTot = 0;
    this.numSeq = 0;
    this.acrescimo = 0;
    this.datMov = '';
  }
}

@Injectable()
export class PedidoProvider {
  constructor(public api: Api, private user: User) {}

  gets(pagination) {
    return this.api.gets('pedido/gets', pagination);
  }

  get(pedido: Pedido) {
    return this.api.get('pedido/get', pedido.seriePedido + '/' + pedido.numPedido);
  }

  post(pedido: Pedido) {
    pedido.idVendedor = this.user.user.idVendedor;
    return this.api.post('pedido/add', pedido);
  }

  put(pedido: Pedido) {
    pedido.idVendedor = this.user.user.idVendedor;
    return this.api.put('pedido/edit', pedido);
  }

  delete(idPedido) {
    return this.api.delete('pedido/del/' + idPedido);
  }
}



// WEBPACK FOOTER //
// ./src/providers/pedido/pedido.ts